import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {GenericErrorResponse, UuidModel} from '../typings';
import {PUT_ENABLE_REQUEST_TYPES_URL} from '../../constants/apiUrls';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutEnableRequestType = ({onSuccess, onError}: Input = {}) => {
  const putEnableRequestType = async (reqBody: UuidModel[]) => {
    await axiosClient.put(PUT_ENABLE_REQUEST_TYPES_URL, reqBody);
  };

  return useCustomMutation(putEnableRequestType, {
    onSuccess,
    onError,
  });
};
